/* eslint-disable no-undef */
import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "@/plugins/bootstrap-vue";
import App from "@/index/App.vue";
import router from "@/router/index.js";

import firebase from "firebase/app";
import "firebase/messaging";

Vue.config.productionTip = false;

const firebaseConfig = {
  apiKey: "AIzaSyDLOyzSYX6uRawhWRRGGwqb-5wvJjfv3Nw",
  authDomain: "quarter-web-push.firebaseapp.com",
  projectId: "quarter-web-push",
  storageBucket: "quarter-web-push.appspot.com",
  messagingSenderId: "400008266357",
  appId: "1:400008266357:web:ce7b996b3b860bf0012e3c",
  measurementId: "G-4KV8XYTC98"
};

firebase.initializeApp(firebaseConfig);

Vue.prototype.$messaging = null;
// Vue.prototype.$database = null;
if (firebase.messaging.isSupported()) {
  Vue.prototype.$messaging = firebase.messaging();
  // Vue.prototype.$database = firebase.database();
  Vue.prototype.$messaging.usePublicVapidKey(process.env.VUE_APP_VAPID_KEY);
}

if ("serviceWorker" in navigator && "PushManager" in window) {
  console.log("Service Worker and Push are supported");
  navigator.serviceWorker
    .register("/sw.js")
    .then(registration => {
      console.log("Service Worker is registered");
      Vue.prototype.$swRegistration = registration;
      Vue.prototype.$messaging.useServiceWorker(registration);
    })
    .catch(err => {
      console.log(err);
    });
} else {
  console.warn("Push messaging is not supported");
}

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
